"use client";

import Tabs from "@/components/custom-tabs";
import FaqAccordion from "@/components/faq";
import { FaqQuestionSchema } from "@/types/faqs";
import { useState } from "react";

function QuestionsSection({ faqs }: Readonly<{ faqs: FaqQuestionSchema[] }>) {
  const SECTIONS = [1, 2, 3, 4];

  const groupedFaqs = SECTIONS.reduce<Record<number, FaqQuestionSchema[]>>(
    (acc, section) => {
      acc[section] = faqs.filter(faq => faq.section === section);
      return acc;
    },
    {}
  );

  const tabs = Object.values(groupedFaqs)
    .filter(items => items.length > 0)
    .map(items => ({
      id: String(items[0].section),
      label: items[0].section_name,
    }));

  const [activeTabId, setActiveTabId] = useState<string>(
    tabs[0]?.id ?? ""
  );

  const activeSection = Number(activeTabId);
  const activeFaqs = activeSection ? groupedFaqs[activeSection] ?? [] : [];

  return (
    <section className="flex flex-col w-full items-center justify-center">
      <Tabs
        tabs={tabs}
        activeTabId={activeTabId}
        onTabChange={setActiveTabId}
        tabsPosition="center"
      />

      <FaqAccordion faqs={activeFaqs} />
    </section>
  )
}

export default QuestionsSection;
